import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { CustomerCardService } from '../../../../services/customer/customer-card.service';
import { AuthService } from '../../../../services/user/auth.service';
import { FormValidationService } from '../../../../services/utils/form-validation.service';
import { SchemaInformationServices } from '../../../../services/entity/schema-information.services';
import { HttpClientService } from '../../../../services/httpClient/httpclient.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-create-customer-ext',
  templateUrl: './create-customer-ext.component.html',
  styleUrls: ['./create-customer-ext.component.css']
})
export class CreateCustomerExtComponent implements OnInit {

  pageTitle = 'Creazione Cliente';
  schemaResult: Object = {};
  formData: FormGroup;
  sessi: Array<{ value: string, label: string }>;

  public maxDate: Date = new Date();

  @ViewChild('birthDateSelector', {read: ElementRef}) birthDateSelector: ElementRef;

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private customerCardService: CustomerCardService,
    private authService: AuthService,
    private srvValidation: FormValidationService,
    private srvNotify: MessageService,
    private schemaInfo: SchemaInformationServices
  ) { }

  resetForm() {
      let dto = 'CustomerFullDto';
      let group: object = {
          cardNo: ['', [Validators.required, Validators.maxLength(13)]],
          surname: ['', [Validators.required, Validators.maxLength(255)]],
          name: ['', [Validators.required, Validators.maxLength(255)]],
          email: ['', KoncentroValidators.emailOrEmpty],
          telephone:      [ '', KoncentroValidators.phone ],
          sex: '',
          birthDate: ['', KoncentroValidators.dateNotAfter(this.maxDate)],
          address1: ['', [Validators.required, Validators.maxLength(255)]],
          addressNumber: ['', [Validators.required, Validators.maxLength(10)]],
          zipCode: ['', [Validators.required, Validators.maxLength(50)]],
          city: ['', [Validators.required, Validators.maxLength(255)]],
          companyCode: this.authService.user.selectedCompany,
          privacyTerminal: true,
          privacyGenericComm: true,
          privacyMktgResearch: true,
          privacyAuth: [true, Validators.requiredTrue],
          privacyMktgProfiling: true,
          privacyMktgActivity: true,
          privacyPurchaseCom: true,
          privacyOptin: true,
          sourceCode: 'VSLP'
      };
      this.schemaInfo.getSchema(HttpClientService.BASE_MS_API + '/schema', dto).subscribe(res => {
          this.schemaResult = res;
          Object.keys(group).forEach(function (key) {
              let validator: any[] = [];
              if ('nullable' in res[key] && res[key].nullable === false) {
                  validator.push(Validators.required);
              }
              if ('type' in res[key]) {
                  if (res[key] === 'String') {
                      // Fa qualcosa
                  } else if (res[key] === 'Numeric') {
                      // Fa qualcosa
                  } else if (res[key] === 'Date') {
                      // Fa qualcosa
                  }
              }
              if ('width' in res[key] && res[key].width > 0) {
                  validator.push(Validators.maxLength(res[key].width));
              }
              if ('pattern' in res[key]) {
                  validator.push(KoncentroValidators.pattern(res[key].pattern));
              }
              if (validator.length > 0) {
                  group[key] = ['', validator];
              }
          });
      });
      this.formData = null;
      this.formData = this.fb.group(group);

      if (this.birthDateSelector) {
        this.birthDateSelector.nativeElement.formData = this.formData;
      }
  }

    /**
     * returns true if the field with the name 'name' is required
     *
     * @param name
     * @return boolean
     */
  checkIfRequired (name: string) {
      if (typeof this.schemaResult[name] !== 'undefined') {
         return !(this.schemaResult[name].nullable);
      }
      return false;
  }

  ngOnInit() {
    this.sessi = [];
    this.translate.get([
      'customerDetail.sex_male',
      'customerDetail.sex_female',
      'customerDetail.sex_other'
    ]).subscribe(t => {

      this.sessi.push(
        { value: 'M', label: t['customerDetail.sex_male']},
        { value: 'F', label: t['customerDetail.sex_female']},
        { value: 'A', label: t['customerDetail.sex_other']}
      );

      this.resetForm();
    });

    this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);
  }

  save() {
    if (!this.formData.valid) {
      console.log('errors', this.formData);

      this.srvValidation.validateAllFormFields(this.formData);

      return false;
    }

    console.log('form data raw value', this.formData.getRawValue());
    const customerData = this.formData.getRawValue();

    customerData.privacyTerminal = customerData.privacyTerminal ? '1' : '0';
    customerData.privacyGenericComm = customerData.privacyGenericComm ? '1' : '0';
    customerData.privacyMktgResearch = customerData.privacyMktgResearch ? '1' : '0';
    customerData.privacyAuth = customerData.privacyAuth ? '1' : '0';
    customerData.privacyMktgProfiling = customerData.privacyMktgProfiling ? '1' : '0';
    customerData.privacyMktgActivity = customerData.privacyMktgActivity ? '1' : '0';
    customerData.privacyPurchaseCom = customerData.privacyPurchaseCom ? '1' : '0';
    customerData.privacyOptin = customerData.privacyOptin ? '1' : '0';
    customerData.birthDate = customerData.birthDate === '' ? null : customerData.birthDate;

    this.customerCardService.createCustomerExt(customerData).subscribe(res => {
      const detail = 'Cliente e Carta creati e associati.' + (res.hostId ? (' Customer Code: ' + res.hostId) : '');

      this.srvNotify.add({severity: 'success', summary: 'Success', detail: detail});

      this.resetForm();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-ext/create-customer-ext/create-customer-ext.component.ts